'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAgentId = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAgentId = exports.getAgentId = (0, _get2.default)('agentId');


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/assignment-v1-message-metadata/operators/assignmentV1MessageMetadataGetters.js
// module id = 871
// module chunks = 2 3